<div class="flex flex-col">
  <label [for]="fieldId" [class]="`${labelClass()}`">
    Tipo de Obra@if (showRequiredSpan()) {
    <span class="required">*</span>
  }
  </label>
  @if (readonly()) {
    <span [id]="fieldId">{{ tipoObraSelecionada()?.nomeTipoObra }}</span>
  } @else {
    <p-select fluid
              [inputId]="fieldId"
              [options]="tiposObraOptions()"
              optionValue="id"
              [filter]="true"
              filterBy="nomeTipoObra"
              optionLabel="nomeTipoObra"
              placeholder="Selecione"
              [ngModel]="initialValue()"
              showClear
              appendTo="body"
              (onChange)="selectionChange.emit($event.value)">
      <ng-template #selectedItem let-selectedOption>
        <div class="flex items-center gap-2">
          <img
            [src]="`assets/icones-tipo-obra/${selectedOption.icone}`"
            [alt]="selectedOption.nomeTipoObra"
            width="18"
            height="18"/>
          <span>{{ selectedOption.nomeTipoObra }}</span>
        </div>
      </ng-template>
      <ng-template let-tipoObra #item>
        <div class="flex items-center gap-2">
          <img
            [src]="`assets/icones-tipo-obra/${tipoObra.icone}`"
            [alt]="tipoObra.nomeTipoObra"
            width="18"
            height="18"/>
          <span>{{ tipoObra.nomeTipoObra }}</span>
        </div>
      </ng-template>
    </p-select>
  }
</div>
